<fin-mmb-promotion
  [order$]="booking$"
  *ngIf="(bookingIsDisrupted$ | async) === false"
  (upsellClicked)="onUpsellClicked($event)"
></fin-mmb-promotion>
@if ((showChildSafetyNotice$ | async) === true) {
  <div
    data-testid="child-safety-notice"
    class="nordic-blue-900-text ps-medium mr-large-b rounded-large shadow alert-100-bg flex flex--column"
  >
    <h3 class="font-heading-3">
      {{ 'MMB.childSafetyNotice.title' | finLocalization }}
    </h3>
    <div class="font-body-1" [innerHtml]="'MMB.childSafetyNotice.content' | finLocalization | finSafe: 'html'"></div>
    <div class="font-body-1 flex flex--end bold-type nordic-blue-900-text">
      <a
        data-testid="kids-in-business-view-requirements-link"
        class="nordic-blue-900-text underline open-modal-link"
        (click)="openKidsInBusinessModal()"
        >{{ 'MMB.childSafetyNotice.link' | finLocalization }}</a
      >
    </div>
  </div>
}
<fin-mmb-trip
  [booking$]="booking$"
  [changeFlightModalOpen$]="changeFlightModalOpen$"
  [showTravelExtrasButton]="(products$ | async)?.length && (bookingIsDisrupted$ | async) === false"
  (emailModalOpen)="openEmailModal($event)"
  (scrollToTravelExtras)="scrollTo(travelExtrasSection)"
  (upsellClicked)="onUpsellClicked($event)"
  class="block mr-large-b"
></fin-mmb-trip>
<fin-included-products
  *ngIf="(bookingIsDisrupted$ | async) === false"
  [booking]="booking$ | async"
  [showTickets]="false"
  [showInformationModal]="true"
  [useCabinClass]="true"
  [servicesToShow]="combinedServices$ | async"
  [upsellInModal$]="upsellInModal$"
  [titleTranslationKey]="'MMB.labels.includedInTrip'"
  [products$]="products$"
  [showUpsell]="true"
  (upsellClicked)="onUpsellClicked($event)"
  (continuePurchase)="onContinuePurchase()"
  class="services block mr-large-b"
></fin-included-products>
<fin-included-products
  *ngIf="(unconfirmedServices$ | async)?.length"
  [booking]="booking$ | async"
  [showTickets]="false"
  [servicesToShow]="unconfirmedServices$ | async"
  [showAsPending]="true"
  [titleTranslationKey]="'MMB.labels.awaitingConfirmation'"
  class="block mr-large-b"
></fin-included-products>

<fin-section-review
  *ngIf="(products$ | async)?.length && (bookingIsDisrupted$ | async) === false"
  [title]="'MMB.view.ancillaries.heading' | finLocalization"
  [noButton]="true"
  class="mr-xsmall-b white-bg"
  #travelExtrasSection
>
  <ng-container ngProjectAs="content">
    <p>{{ 'MMB.view.ancillaries.text' | finLocalization }}</p>
  </ng-container>
</fin-section-review>

<fin-mmb-ancillaries
  *ngIf="
    (bookingIsDisrupted$ | async) === false && (booking$ | async).eligibilities.serviceCatalog.isAllowedToUse === true
  "
  (emailModalOpen)="openEmailModal($event)"
  (scrollToTravelExtras)="scrollTo(travelExtrasSection)"
  [openAncillarySubview$]="openAncillarySubview$"
  [products$]="products$"
  [order$]="booking$"
>
</fin-mmb-ancillaries>

<div *ngIf="(bookingIsDisrupted$ | async) === false" class="mr-medium-b">
  <fin-sustainability-review-card
    *ngIf="enableShowingSAF"
    [isLinkExternal]="true"
    [showHeader]="false"
  ></fin-sustainability-review-card>

  <fin-promotion-banners [orderData$]="booking$"></fin-promotion-banners>
</div>

<fcom-modal
  [title]="(isTravelExtraModal ? 'MMB.login.email.travelExtras.title' : 'MMB.login.group.title') | finLocalization"
  [buttons]="ModalButtons.CUSTOM"
  [fitToContent]="true"
  (close)="onEmailModalClose()"
  [isOpen]="showGroupBookingEmailModal$ | async"
>
  <div class="block pr-large">
    <h2 class="nordic-blue-900-text font-heading-3 mr-small-b">
      {{ 'MMB.login.email.heading' | finLocalization }}
    </h2>
    <p class="mr-small-b">
      {{ (isTravelExtraModal ? 'MMB.login.email.travelExtras.info' : 'MMB.login.email.info') | finLocalization }}
    </p>

    <form [formGroup]="groupEmailForm" (ngSubmit)="onSubmitEmail()" data-group-booking-email-form>
      <fin-form-fields>
        <fin-form-group
          class="block pr-xsmall-b"
          [translationPrefix]="'paxDetails.fields'"
          [group]="groupEmailForm"
          [inline]="true"
        >
          <fin-input-field
            [translationPrefix]="'paxDetails.fields.email'"
            class="block pr-xsmall-b"
            [group]="groupEmailForm"
            [modelName]="'email'"
            [type]="'email'"
            [required]="true"
            [name]="'email'"
            (focus)="focusEvent.emit($event)"
            (blur)="blurEvent.emit()"
          >
          </fin-input-field>
        </fin-form-group>
      </fin-form-fields>
    </form>

    <fcom-notification
      *ngIf="groupModalError$ | async as error"
      [theme]="NotificationTheme.ALERT"
      [layout]="NotificationLayout.BLOCK"
      aria-live="polite"
    >
      {{ 'MMB.login.errors.' + error | finLocalization }}
    </fcom-notification>
  </div>

  <div buttons>
    <fcom-button
      [type]="ButtonType.SUBMIT"
      data-testid="group-booking-email-submit"
      [disabled]="!groupEmailForm.valid"
      *ngIf="(loading$ | async) === false"
      (clickBtn)="onSubmitEmail()"
      [text]="'actions.continue' | finLocalization"
      [aria]="{ label: 'actions.continue' | finLocalization, role: 'button' }"
      class="mr-xsmall-r"
    ></fcom-button>
    <fcom-loader *ngIf="loading$ | async" class="pr-xsmall block" [loaderType]="LoaderTheme.INLINE"> </fcom-loader>
  </div>
</fcom-modal>

<fcom-modal
  [open]="kidsInBusinessModalOpen$ | async"
  [title]="'kidsInBusinessNotification.modalTitle' | finLocalization"
  [buttons]="ModalButtons.CLOSE"
  [fullHeight]="true"
  (close)="closeKidsInBusinessModal()"
  data-testid="kids-in-business-modal"
>
  <div class="nordic-blue-900-text pr-large-x pr-small-y">
    <cms-rich-text
      *ngFor="let article of content$ | async"
      data-testid="first-content"
      [content$]="article | finToObservable"
      [headerStyles]="['font-heading-4']"
    ></cms-rich-text>
  </div>
</fcom-modal>
